export default {

  //  CSAK staistics dashboard статистика для ТСАКа 
  SET_STATISTIC_DASHBOARD_CSAK(state, data) { 
    let newList = [...data]
    newList.sort((a, b) => a.region.localeCompare(b.region)) // сортирую список по алфавиту 

    const ind = newList.findIndex(el => el.region.toLowerCase().startsWith('республика')) //на хожу элемент который начинается с 'республика'
    let repub = newList.splice(ind, 1) // вырезаю этот элемент из массива 

    const tasInd = newList.findIndex(el => el.region.toLowerCase().startsWith('г.')) //на хожу элемент который начинается с 'г.'
    let tash = newList.splice(tasInd, 1) // вырезаю этот элемент из массива 

    const allInd = newList.findIndex(el =>  el.region.toLowerCase().startsWith('все')); //на хожу элемент который начинается Все регионы 
    let allR = newList.splice(allInd, 1); // вырезаю этот элемент из массива

    newList.unshift(...repub) // добавляю республика каракалпакстан в начало списка 
    newList.splice(11, 0, ...tash) // добавляю город ташкент   после ташкентской области 
    newList.push(...allR); // добавляю Все регионы в конец списка
 
    state.statisticDashboardCsak = newList

  },
  //  CSAK staistics dashboard статистика для ТСАКа 


  /////////////////
  // COMPANY OBJECTS 
  /////////////////

  // SET_COMPANY_OBJECTS(state, objects) {
  //   state.objects = objects
  // },
  // ADD_COMPANY_OBJECTS(state, objects) {
  //   state.objects.push(objects)
  // },
  // EDIT_COMPANY_OBJECTS(state, value) {
  //   const userIndex = state.objects.findIndex((u) => u.id === value.id)
  //   state.objects.splice(userIndex, 1, value)
  // },
  SET_DAILY_POLLUTION_EMISSION_WITH_FILTER(state, data) {
    state.emissionsDataTable.push(data)
  },
  CLEAR_DAILY_POLLUTION_EMISSION_WITH_FILTER(state) {
    state.emissionsDataTable = []
  },

  // Добавление всех статусов в сторе 
  SET_EMISSIONS_STATUSES(state, statuses) {
    state.emissionsStatuses = statuses
  }



}